import styled from "styled-components";
//import { colors } from '../../globalStyles/colors';

export const Container = styled.div`
  background: #f0f0f0;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 30px;
  padding-left: 15px;
  padding-right: 0;
  //flex-direction: row;
  //max-width:100vw;
  .mr-30 {
    margin-right: 30px;
  }
  .mr-15 {
    margin-right: 30px;
  }

  .ml-15 {
    margin-left: 15px;
  }

  .mt-15 {
    margin-top: 15px;
  }

  .mb-15 {
    margin-bottom: 15px;
  }

  .flex_roll {
    display: flex;
    flex-direction: row;
  }

  .align_center {
    align-items: center;
  }

  .justify_content_between {
    justify-content: space-between;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 80px;
  //flex: 1;
  align-items: center;
  padding-left: 20px;
  //padding-right: 20px;
  padding-top: 24px;
  padding-bottom: 24px;

  border: solid;
  border-top: 0;
  border-left: 0;
  border-right: 0;

  border-bottom-width: 1px;
  border-color: #e5e5e5;

  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 16px 16px #00000014;
  border-radius: 24px;

  position: relative;

  margin-bottom: 16px;
  //background:#000
  //max-width:100vw;

  .dropdown-menu {
    min-width: 208px;
    background: #f8f8f8 0% 0% no-repeat padding-box;

    .dropdown-item {
      text-align: left;
      font: normal normal normal 14px/19px Roboto;
      letter-spacing: 0px;
      color: #222222;

      background: #ffffff 0% 0% no-repeat padding-box;

      :hover {
        background: rgba(255, 255, 255, 0.3) 0% 0% no-repeat padding-box;
      }
    }
  }

  .dropdown-none {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    font-size: 0 !important;
    padding: 0 !important;
  }

  justify-content: space-between;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 80px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .dropdown-menu {
    background: transparent !important;
    border: 0 !important;
  }
  .dropdown-item {
    background: #ffffff;
  }
  .dropdown-item {
    :hover {
      background: #f0f0f0 !important;
    }
  }
`;

export const HeaderExport = styled.div`
  background: #18aa36 0% 0% no-repeat padding-box;
  border-radius: 15px;
  height: 30px;
  width: 130px;
  //text-align: center;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  //padding-right: 8px;

  .ExportDropdown {
    font: normal normal normal 12px/16px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
    text-transform: uppercase;
    opacity: 1;
    vertical-align: center;
    // text-align: left;
    width: 100%;
    img {
      width: 16px;
      height: 16px;
      justify-self: center;
      align-self: center;
      text-align: center;
    }
  }
  .ExportArrowDown {
    //flex:1;
    border-radius: 0px 15px 15px 0px;
    height: 100%;

    :hover {
      background-color: #12842a;
    }
  }
`;

export const HeaderTitle = styled.p`
  text-align: left;
  font: normal normal 500 18px/24px Roboto;
  letter-spacing: 0px;
  color: #222222;

  opacity: 1;
  text-transform: capitalize;
  margin: 0;
  margin-right: 23px;
  white-space: nowrap;

  .parent_header {
    font: normal normal normal 18px/24px Roboto;
    letter-spacing: 0px;
    color: #676767;
  }
  .next_item {
    font: normal normal normal 18px/24px Roboto;
    letter-spacing: 0px;
    color: #7d9828;
  }
  .title_header {
  }
`;

interface HeaderButtonProps {
  active: boolean;
}

export const HeaderButton = styled.button<HeaderButtonProps>`
  cursor: pointer;
  background: ${(props) => (props.active ? "#18AA36" : "#F2F2F2")};
  //border: ${(props) => (props.active ? "1px solid #09aa36" : 0)};
  border: 0;
  box-shadow: ${(props) => (props.active ? "0px 0px 8px #00000029" : 0)};
  border-radius: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-right: 16px;
  padding-left: 16px;
  margin-right: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  p {
    text-align: center;
    font: normal normal normal 12px/16px Roboto;
    letter-spacing: 0px;
    color: ${(props) => (props.active ? "#FFFFFF" : "#676767")};
    text-transform: uppercase;
    margin: 0;
    white-space: nowrap;
  }

  .MenuPersonalizadoSvgContainer {
    background: ${(props) =>
      props.active
        ? "#0D5E1E 0% 0% no-repeat padding-box"
        : "transparent 0% 0% no-repeat padding-box"};
    margin-right: 3px;
    width: 44px;
    height: 29px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    margin-top: -6px;
    margin-bottom: -6px;
    margin-left: -16px;
  }

  svg {
    color: ${(props) => (props.active ? "#FFFFFF" : "#676767")};
    width: 13px;
    height: 13px;
  }
`;

export const HeaderUserContainer = styled.div`
  position: absolute;
  right: 20px;

  height: 40px;

  .dropdown-toggle-categoria {
    padding: 0;
  }

  .header_user_flex {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .user_circle {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #18aa36;
    opacity: 1;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font: normal normal 500 14px/19px Roboto;
    letter-spacing: 0px;
    color: #18aa36;
    text-transform: uppercase;
    vertical-align: center;
  }
`;

interface HeaderSearchContainerProps {
  active: boolean;
}

export const HeaderSearchContainer = styled.div<HeaderSearchContainerProps>`
  height: 40px;
  display: flex;
  flex-direction: row;

  background: #f0f0f0 0% 0% no-repeat padding-box;
  border-radius: 20px;
  border: 0;
  opacity: 1;
  align-items: center;
  min-width: 230px;

  margin-right: 24px;

  input {
    //display: ${(props) => !props.active && "none"};
    transition: all 1s;
    width: ${(props) => (!props.active ? 0 : "150px")};
    // margin-left: ${(props) => (!props.active ? 0 : "16px")};
    padding: ${(props) => (!props.active ? 0 : "11px")};
  }

  button {
    cursor: pointer;
    padding: 11px;
    background: transparent;
    border: 0;
    display: flex;
    align-items: center;
  }

  svg {
    color: #09aa36;
    width: 16px;
    height: 16px;
  }
`;

export const HeaderSearchInput = styled.input`
  text-align: left;
  font: normal normal normal 14px/19px Roboto;
  letter-spacing: 0px;
  color: #9f9f9f;
  opacity: 1;
  flex: 1;
  border: 0;
  background-color: transparent;
  //padding:11px;
`;
interface BodyProps {
  showScroll?: boolean;
}

export const Body = styled.div<BodyProps>`
  //padding: 25px;
  //position: relative;
  padding-bottom: 0;
  flex: 1;
  //height: 100%;
  overflow-y: hidden;
  height: calc(100vh - 80px - 20px - 50px);

  border-radius: 24px;

  ::-webkit-scrollbar {
    background: transparent;

    // display:none;

    width: 0;
  }

  &::-webkit-scrollbar-track {
  }
  /*  margin-top:0;
      border-bottom-right-radius: 16px;
      background-image: url("https://i.stack.imgur.com/Pwbuz.png");
    background-repeat: repeat-y;
    background-size: contain;
      
		// margin-top: 54px;
	}
	&::-webkit-scrollbar-thumb {
		background: ${(props) =>
    props.showScroll ? "rgba(103, 103, 103, 0.5)" : "transparent"};
		border-radius: 20px;
		border: 2.5px solid rgba(0, 0, 0, 0);
		border-right: 5px solid rgba(0, 0, 0, 0);

		background-clip: padding-box;
		max-height: 5px;
		transition: all 1s;
	}
	//padding-right: 30px;
	/*overflow-y: scroll;
	//background:#000;

	

	
	*/
`;

export const Card = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 16px 16px #00000014;
  border-radius: 24px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  flex: 1;
  // max-height: 150px;
  //margin-bottom: 15px;
`;

export const CardRow = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 16px 16px #00000014;
  border-radius: 24px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  //margin-right: 13px;
  flex: 1;

  .dropdown-dash-toggle {
    font-size: 0 !important;
    background: transparent !important;
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0;
  }

  .dropdown-dash-toggle ::after {
    color: "#FFF";
  }
`;

export const CardItem = styled.div`
  //margin-left: 15px;
  //margin-right: 15px;
  flex: 1;
  padding: 20px;

  .card_item_small_text {
    text-align: left;
    font: normal normal 500 15px/20px Roboto;
    letter-spacing: 0px;
    color: #222222;
    margin: 0;
  }

  .card_item_big_text {
    font: normal normal 500 28px/37px Roboto;
    letter-spacing: 0px;
    color: #222222;
    margin: 0;
  }
`;

export const CardMeasureTitle = styled.p`
  margin: 0;
  font: normal normal 500 15px/20px Roboto;
  letter-spacing: 0px;
  color: #222222;
  opacity: 1;
  text-align: left;
`;

export const CardTitle = styled.p`
  text-align: left;
  font: normal normal 500 20px/26px Roboto;
  letter-spacing: 0px;
  color: #222222;
  opacity: 1;
  margin-bottom: 15px;
  margin: 0;
  //vertical-align: middle;
`;

export const GreenLine = styled.div`
  border: 1px solid #7d9828;
  opacity: 1;
  max-width: 35px;
  margin-top: 5px;
`;

export const RelatoriosContainer = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 24px;
  opacity: 1;
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  display: flex;
  flex-direction: column;

  .align-self-right {
    align-self: flex-end;
  }

  .MuiPaginationItem-rounded {
    border-radius: 16px;
  }

  .pagination_container {
    width: calc(100% - 10px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    //position: -webkit-;
    bottom: 5px;
    background: #f9f9f9 0% 0% no-repeat padding-box;
    border-radius: 18px;
    margin-left: 5px;
    margin-right: 5px;
    padding-left: 8px;

    .pagination_text {
      margin: 0;
      text-align: left;
      font: normal normal normal 12px/16px Roboto;
      letter-spacing: 0px;
      color: #222222;
      .pagination_text_bold {
        font: normal normal bold 12px/16px Roboto;
      }
    }

    .table_footer_border_right {
      border-right: 1px solid #d3d3d3;
    }
    .table_footer_padding_right-20 {
      padding-right: 20px;
    }
    .table_footer_margin_left-20 {
      margin-left: 20px;
    }

    .table_footer_border_right-12 {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }

    .table_footer_border_left-12 {
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }

    .table_footer_button_container {
      background: #18aa36 0% 0% no-repeat padding-box;
      height: 24px;
      width: 70px;
      display: flex;
      flex-direction: row;

      img {
        width: 16px;
        height: 16px;
      }
    }

    .table_footer_button {
      flex: 1;
      :hover {
        background: #12842a 0% 0% no-repeat padding-box;
      }
      color: #ffffff;
      border: 0;
      background-color: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .table_footer_label {
      margin: 0;
      margin-bottom: 0;
      text-align: left;
      font: normal normal normal 12px/16px Roboto;
      letter-spacing: 0px;
      color: #222222;
    }
    .table_footer_label_strong {
      font: normal normal bold 12px/16px Roboto;
    }

    .table_footer_input {
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 1px solid #d3d3d3;
      border-radius: 12px;
      height: 24px;
      width: 48px;
      text-align: center;
      font: normal normal bold 14px/19px Roboto;
      letter-spacing: 0px;
      color: #222222;
      margin-right: 9px;
      margin-left: 9px;
    }
    .table_footer_border_right {
      border-right: 1px solid #d3d3d3;
    }

    .table_footer_padding_right-20 {
      padding-right: 20px;
    }
    .table_footer_margin_left-20 {
      margin-left: 20px;
    }

    .table_footer_border_right-12 {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }

    .table_footer_border_left-12 {
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }

    .table_footer_button_container {
      background: #18aa36 0% 0% no-repeat padding-box;
      height: 24px;
      width: 70px;
      display: flex;
      flex-direction: row;

      img {
        width: 16px;
        height: 16px;
      }
    }

    .table_footer_button {
      flex: 1;
      :hover {
        background: #12842a 0% 0% no-repeat padding-box;
      }
      color: #ffffff;
      border: 0;
      background-color: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .not_found_text {
    text-align: left;
    font: normal normal normal 12px/16px Roboto;
    letter-spacing: 0px;
    color: #222222;
    width: 100%;
    background: #f9f9f9 0% 0% no-repeat padding-box;
    border-radius: 18px;
    padding: 16px;
  }
`;

interface RelatorioItemProps {
  width?: string;
}
export const RelatorioItem = styled.div<RelatorioItemProps>`
  //flex: 1;

  //display: flex;
  //flex-direction: column;

  width: ${(props) => (props.width ? props.width : "170")}px;
  //width: 100%;
  .dropdown-none {
    background: transparent !important;
    border: 0 !important;
    box-shadow: none !important;
    font-size: 0 !important;
    padding: 0 !important;
  }
`;

export const FilterDropdown = styled.div<RelatorioItemProps>`
  background: #f6f6f6 0% 0% no-repeat padding-box;
  border-radius: 19px;
  height: 38px;
  width: ${(props) => (props.width ? props.width : "170")}px;
  //text-align: center;

  display: flex;
  align-items: center;
  //justify-content: space-between;
  padding-left: 16px;
  //padding-right: 8px;

  .ExportDropdown {
    text-align: left;
    font: normal normal normal 14px/19px Roboto;
    letter-spacing: 0px;
    color: #b5b5b5;
    opacity: 1;
    vertical-align: center;
    // text-align: left;
    //width: 100%;
    flex: 1;
    img {
      width: 16px;
      height: 16px;
      justify-self: center;
      align-self: center;
      text-align: center;
    }
  }
  .ExportArrowDown {
    //flex:1;
    background: #e6e6e6 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    border-radius: 0px 19px 19px 0px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;

    img {
      height: 16px;
      width: 16px;
    }
    :hover {
      //background-color: #12842a;
    }
  }
`;

export const RelatoriosSelectContainer = styled.form`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  .dropdown-toggle-categoria {
    padding: 0;
    background: transparent !important;
    border: 0 !important;

    box-shadow: none !important;

    outline: none !important;

    font-size: 0;
  }

  .dropdown-toggle-categoria:hover {
    background: transparent !important;
  }

  .dropdown-toggle-categoria svg {
    width: 16px;
    height: 36px;
    color: #09aa36 !important;
  }

  //	background:#000;

  .label_title {
    text-align: left;
    font: normal normal 500 15px/20px Roboto;
    letter-spacing: 0px;
    color: #033463;
    margin: 0px;
    margin-bottom: 2px;
    padding-left: 10px;
  }
  .relatorios_input {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    border: 0;
    border-radius: 19px;
    height: 38px;
    width: 100%;
    padding-left: 15px;
  }

  .relatorios_button {
    background: #092a60 0% 0% no-repeat padding-box;
    border: 0;
    border-radius: 19px;
    height: 38px;

    font: normal normal normal 16px/21px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
  }

  //justify-content: space-between;
`;

export const PaginationContainer = styled.div``;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;

  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #09aa36;
  border-radius: 10px;
  opacity: 1;
  align-items: center;
`;

interface SearchSelectorProps {
  active?: boolean;
  pressed?: boolean;
}
export const SearchSelector = styled.button<SearchSelectorProps>`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  margin-right: 10px;

  background: ${(props) => (props.active ? "#18AA36" : "#F0F0F0")} 0% 0%
    no-repeat padding-box;
  border-radius: 20px;

  text-align: center;
  font: normal normal 500 12px/16px Roboto;
  letter-spacing: 0px;
  color: ${(props) => (props.active ? "#FFFFFF" : "#676767")};
  text-transform: uppercase;
  cursor: pointer;
  border: ${(props) =>
    props.pressed ? "1px solid #EBEBEB" : "1px solid transparent"};

  box-shadow: ${(props) => (props.pressed ? "inset 0px 3px 6px #00000029" : 0)};
`;

export const SelectMenu = styled.div`
  background: #f6f6f8 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 12px #0000001a;
  border: 1px solid #ebebeb;
  border-radius: 18px;
  padding: 10px;
  padding-bottom: 2px;
  margin-top: 6px;

  //overflow-y: scroll;
  // max-height: 30vh;
  ::-webkit-scrollbar {
    width: 0px;
  }
  .dropdown-item {
    :hover {
      background: transparent;
    }
  }
`;

export const SelectSearchMenu = styled.div`
  background: #f6f6f8 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 12px #0000001a;
  border: 1px solid #ebebeb;
  border-radius: 18px;
  padding: 10px;
  padding-bottom: 2px;
  margin-top: 6px;

  ::-webkit-scrollbar {
    width: 0px;
  }
  .dropdown-item {
    :hover {
      background: transparent;
    }
  }

  .scroll-container {
    overflow-y: scroll;
    ::-webkit-scrollbar {
      width: 0px;
    }
    max-height: 200px;
  }
`;

export const SelectItem = styled.div<SearchSelectorProps>`
  background: ${(props) => (props.active ? "#18aa36" : "transparent")} 0% 0%
    no-repeat padding-box;
  // background: #FFFFFF 0% 0% no-repeat padding-box;

  border-radius: 18px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 16px;
  height: 35px;
  width: 150px;

  text-align: left;
  font: normal normal ${(props) => (props.active ? 500 : "normal")} 14px/19px
    Roboto;
  letter-spacing: 0px;
  color: ${(props) => (props.active ? "#FFFFFF" : "#676767")};

  :hover {
    box-shadow: 0px 6px 12px #22222226;
    background: ${(props) => (props.active ? "#18aa36" : "#FFFFFF")} 0% 0%
      no-repeat padding-box;
    font: normal normal 500 14px/19px Roboto;
  }
`;

export const SelectItemList = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  // background: #FFFFFF 0% 0% no-repeat padding-box;

  display: flex;
  align-items: center;
  // justify-content: center;
  height: 35px;
  width: 300px;
  margin-bottom: 2px;

  text-align: left;
  font: normal normal normal 14px/19px Roboto;
  letter-spacing: 0px;
  color: #676767;
  padding-left: 20px;
`;

export const RelatoriosSelectBlock = styled.div`
  border: solid;
  margin: 0;
  border-top: 0;
  border-right: 0;
  border-left: 0;

  border-bottom-width: 1px;
  border-bottom-color: #09aa36;
  padding-left: 7px;
  padding-right: 7px;
  margin-right: 15px;
`;

export const RelatorioBlockTitle = styled.p`
  margin: 0;
  text-align: left;
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0px;
  color: #676767;
  opacity: 1;
`;

export const RelatorioSelect = styled.select`
  background: transparent;
  border: 0;
  cursor: pointer;

  text-align: left;
  font: normal normal 500 16px/21px Roboto;
  letter-spacing: 0px;
  color: #09aa36;

  width: 150px;

  option {
    color: #222222;
  }
`;
export const DropDownContainer = styled.div`
  width: 150px;
`;

export const DropDownHeader = styled.div`
  cursor: pointer;
`;

export const LimparFiltrosButton = styled.button`
  cursor: pointer;
  border: 0;
  background: #09aa36 0% 0% no-repeat padding-box;
  border-radius: 10px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  // vertical-align: bottom;
  padding-right: 10px;
  padding-left: 10px;

  svg {
    color: #ffffff;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    vertical-align: middle;
  }
  p {
    margin: 0;
    text-align: center;
    font: normal normal 500 14px/19px Roboto;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
  }
`;

export const TableFooter = styled.div`
  position: sticky;
  position: -webkit-sticky;
  background: #f9f9f9 0% 0% no-repeat padding-box;
  border-radius: 18px;
  height: 36px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  //z-index: 20000;
  padding-left: 16px;
  padding-right: 11px;
  p {
    margin: 0;
  }

  .table_footer_label {
    margin: 0;
    margin-bottom: 0;
    text-align: left;
    font: normal normal normal 12px/16px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }
  .table_footer_label_strong {
    font: normal normal bold 12px/16px Roboto;
  }

  .table_footer_input {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #d3d3d3;
    border-radius: 12px;
    height: 24px;
    width: 48px;
    text-align: center;
    font: normal normal bold 14px/19px Roboto;
    letter-spacing: 0px;
    color: #222222;
    margin-right: 9px;
    margin-left: 9px;
  }
  .table_footer_border_right {
    border-right: 1px solid #d3d3d3;
  }

  .table_footer_padding_right-20 {
    padding-right: 20px;
  }
  .table_footer_margin_left-20 {
    margin-left: 20px;
  }

  .table_footer_border_right-12 {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  .table_footer_border_left-12 {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  .table_footer_button_container {
    background: #18aa36 0% 0% no-repeat padding-box;
    height: 24px;
    width: 70px;
    display: flex;
    flex-direction: row;

    img {
      width: 16px;
      height: 16px;
    }
  }

  .table_footer_button {
    flex: 1;
    :hover {
      background: #12842a 0% 0% no-repeat padding-box;
    }
    color: #ffffff;
    border: 0;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

interface TableContainerProps {
  pagShowing?: boolean;
  isEmpty?: boolean;
}

export const TableContainer = styled.div<TableContainerProps>`
  //	margin-top: 20px;
  height: ${(props) =>
    props.pagShowing
      ? "calc(100vh - 25px - 64px - 25px - 40px - 20px - 65px - 55px - 10px - 5px + 15px + 38px)"
      : "calc(100vh - 25px - 64px - 25px - 40px - 20px - 65px - 55px - 10px + 25px + 50px)"};

  overflow-y: scroll;

  overflow-x: hidden;
  // padding-bottom: 40px;

  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;

  ::-webkit-scrollbar {
    width: 0px;
  }
`;

export const Table = styled.table`
  border: 0;
  width: 100%;
  border-spacing: 0px 0px;
  border-radius: 10px;
`;

export const THead = styled.thead`
  //background: #09aa36 0% 0% no-repeat padding-box;
  //border-radius: 100px;
  border: 0;
  width: 100%;

  tr {
    //border-radius: 100px;
    height: 40px;
    //background-color:#000
  }

  th {
    //border: solid 1px #000;
    //border-style: none none;
    padding: 10px;
    //padding: 9=;
    //background-color: cyan;
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
    background: #f4f4f4 0% 0% no-repeat padding-box;
    :first-child {
      border-left-style: solid;
      //border-top-left-radius: 10px;
      //border-bottom-left-radius: 10px;
      padding-left: 24px;
    }
    :last-child {
      border-right-style: solid;
      //border-bottom-right-radius: 10px;
      //border-top-right-radius: 10px;
    }
  }
`;

interface Thprops {
  active?: boolean;
}

export const Th = styled.th<Thprops>`
  text-align: left;
  font: normal normal bold 14px/19px Roboto;
  letter-spacing: 0px;
  color: #222222;
  //text-transform: uppercase;
  border: 0;
  background-color: transparent;
  //border-radius:10px;

  border-left: ${(props) => (props.active ? "8px solid #f4f4f4" : "")};
  z-index:30;
`;

export const TBody = styled.tbody``;

interface BodyTRprops {
  active?: boolean;
}

export const BodyTR = styled.tr<BodyTRprops>`
  padding-top: 22px;
  padding-bottom: 22px;
  padding-right: 20px;
  padding-left: 20px;
  background-color: #ffffff;

  :hover {
    background: #f7fcf8 0% 0% no-repeat padding-box;
  }

  td {
    //border: solid 1px #000;
    //border-style: none none;
    padding-left: 10px;
    padding-right: 10px;
    //background-color: cyan;
    text-align: left;
    font: normal normal 500 14px/19px Roboto;
    letter-spacing: 0px;
    color: #676767;
    height: 60px;

    :first-child {
      //border-left-style: solid;
      /*border-top-left-radius: 10px;
			border-bottom-left-radius: 10px;*/
      padding-left: 24px;
      border-left: 8px ${(props) => (props.active ? "#18AA36" : "transparent")}
        solid;

      :hover {
        border-left: 8px ${(props) => (props.active ? "#18AA36" : "#f7fcf8")}
          solid;
      }
    }
    :last-child {
      //border-right-style: solid;
      /*border-bottom-right-radius: 10px;
			border-top-right-radius: 10px;*/
    }
  }

  .td_text {
    margin: 0;
    text-align: left;
    font: normal normal 500 14px/19px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }

  .td_item {
    margin: 0;
    text-align: left;
    font: normal normal normal 14px/19px Roboto;
    letter-spacing: 0px;
    color: #222222;
  }

  .td_subtext {
    margin: 0;
    text-align: left;
    font: normal normal medium 14px/19px Roboto;
    letter-spacing: 0px;
    color: #676767;
  }
`;

interface TdStatusProps {
  color?: string;
  backgroundColor?: string;
}

export const TdStatus = styled.div<TdStatusProps>`
  margin: 0;
  text-align: left;
  font: normal normal bold 14px/19px Roboto;
  letter-spacing: 0px;
  color: ${(props) => (props.color ? props.color : "#222222")};
  background: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : "transparent"};
  height: 30px;
  border-radius: 40px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;

export const Detalhes = styled.button`
  border: 0;

  cursor: pointer;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #dee2e6;
  border-radius: 16px;

  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;

  text-align: center;
  font: normal normal normal 14px/19px Roboto;
  letter-spacing: 0px;
  color: #222222;
  opacity: 1;
`;

export const Gradient = styled.div`
  position: sticky;
  bottom: 0;

  background: transparent linear-gradient(180deg, #f5f5f500 0%, #f5f5f5 100%) 0%
    0% no-repeat padding-box;
  margin-top: -32px;
  height: 32px;
  width: 100%;
`;

export const Skeleton = styled.div`
  background-image: linear-gradient(
    -90deg,
    #fafafc 0%,
    #e4e4e4 50%,
    #fafafc 100%
  );
  background-size: 400% 400%;
  animation: shimmer 1.2s ease-in-out infinite;
  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`;

export const SkeletonGreen = styled.div`
  background-image: linear-gradient(
    -90deg,
    var(--primaryColorDark) 0%,
    #abdb30 50%,
    var(--primaryColorDark) 100%
  );
  background-size: 400% 400%;
  animation: shimmer 1.2s ease-in-out infinite;
  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
`;

export const NotFoundContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 50px);
  img {
    width: 326px;
    height: 280px;
  }
`;

export const ExportHeaderMenu = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 16px 16px #00000014;
  border-radius: 16px;
  overflow: hidden;

  .export_header_menu_title {
    background: #f8f8f8 0% 0% no-repeat padding-box;
    border: 1px solid #dee2e6;
    border-radius: 16px 16px 0px 0px;
    font: normal normal 500 14px/19px Roboto;
    letter-spacing: 0px;
    color: #222222;
    padding-top: 8px;
    padding-bottom: 10px;
    padding-left: 20px;
  }
  .dropdown-item {
    text-align: left;
    font: normal normal normal 14px/19px Roboto;
    letter-spacing: 0px;
    color: #222222;
    padding-top: 8px;
    padding-bottom: 10px;
    padding-left: 20px;
  }
`;

export const NewButton = styled.button`
  outline: 0;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #1069d9 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: left;
  font: normal normal 500 15px/20px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  width: 120px;
  height: 40px;

  img {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
`;

export const ChannelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  .channel_item {
    width: 34px;
    height: 34px;
    // background: var(---1069d9-em-andamento) 0% 0% no-repeat padding-box;
    // border: 2px solid var(--branco);
    background: #1069d9 0% 0% no-repeat padding-box;
    :hover {
      background: #3585e6 0% 0% no-repeat padding-box;
    }
    border: 2px solid #ffffff;
    border-radius: 19px;
    opacity: 1;
    img {
      width: 16px;
      height: 16px;
    }
  }
`;
